import React, { useEffect, useState, useRef } from "react";
import SidebarExtensionLink from "./SidebarExtensionLink";
import { withRouter } from "react-router";
import { useStorage } from "../../../Utils/Utils";
import "./SidebarExtensionLinkList.scss";
import { ChevronDown, ChevronUp } from "react-feather";

const SidebarExtensionLinkList = ({ links, location }) => {
	const [me, setMe] = useState(null)
	const [hiddenGroups, setHiddenGroups] = useState([])
	const [groupHeights, setGroupHeights] = useState({})
	
	const filteredLinks = me && links ? links.filter(link => !link.requires || me && me.perms.includes(link.requires)) : []

	const storage = useStorage();

	const toggleGroup = (group) => {
		if (hiddenGroups.includes(group)) {
			setHiddenGroups(hiddenGroups.filter(g => g !== group))
		} else {
			setHiddenGroups([...hiddenGroups, group])
		}
	}

	useEffect(() => {
		storage.getOrFetch("/crm/me").then((me) => {
			setMe(me)
		});
	});

	const groupedLinks = filteredLinks.reduce((acc, link) => {
		const group = link.group || "Other";
		if (!acc[group]) {
			acc[group] = [];
		}
		acc[group].push(link);
		return acc;
	}, {})
	
	const groups = Object.keys(groupedLinks).sort((a, b) => {
		if (a === "Other") return 1;
		if (b === "Other") return -1;
		return a.localeCompare(b);
	})

	const listIsGrouped = filteredLinks.some(link => link.group)

	// Calculate group heights by summing individual link heights for the hide and show functionality
	useEffect(() => {
		const calculateGroupHeights = () => {
			const newHeights = {};
			
			groups.forEach(group => {
				const headerHeight = 32;
				let linksHeight = 0;
				
				// Sum up the height of each link in the group
				groupedLinks[group].forEach((link, idx) => {
					const linkElement = document.getElementById(`link-${group}-${idx}`);
					if (linkElement) {
						linksHeight += linkElement.offsetHeight;
					}
				});

				newHeights[group] = headerHeight + linksHeight;
			});
			
			setGroupHeights(newHeights);
		};

		calculateGroupHeights()
		
	}, []);

	const getGroupHeight = (group) => {
		if (hiddenGroups.includes(group)) {
			return '32px';
		}
		return groupHeights[group] ? `${groupHeights[group]}px` : 'auto';
	};

	return (
		<div className="sidebar-extension-link-list">
			{listIsGrouped 
			? groups.map((group, idx) => (
				<div 
					key={idx} 
					className={`sidebar-extension-link-group`} 
					style={{
						height: getGroupHeight(group),
						overflow: 'hidden',
						transition: 'height 0.3s ease'
					}}
				>
					<div className="sidebar-extension-link-group-header" onClick={() => toggleGroup(group)}>
						{group}
						{hiddenGroups.includes(group) ? <ChevronUp size={16} color="#0E8EFD" /> : <ChevronDown size={16} color="#0E8EFD" />}
					</div>
					{groupedLinks[group].map((link, linkIdx) => (
						<SidebarExtensionLink 
							id={`link-${group}-${linkIdx}`}
							link={link.path} 
							active={location.pathname.includes(link.path)} 
							key={linkIdx}
						>
							{link.name}
						</SidebarExtensionLink>
					))}
				</div>
			))
			: filteredLinks && filteredLinks.length > 0 && filteredLinks.map((link, idx) => (
				<SidebarExtensionLink link={link.path} active={location.pathname.includes(link.path)} key={idx}>{link.name}</SidebarExtensionLink>
			))}
		</div>
	);
} 

export default withRouter(SidebarExtensionLinkList);